export default "__VITE_ASSET__BdppMeKO__"